const PROBLEMS = [
  {
    n: '01',
    title: 'Planning is manual.',
    body: 'Schedules, estimates, and strategies rebuilt by hand in every office.',
  },
  {
    n: '02',
    title: 'Execution is disjointed.',
    body: 'Disconnected legacy systems. Context lost at every handoff.',
  },
  {
    n: '03',
    title: "Speed can't scale.",
    body: 'Lessons stay local and evaporate with turnover.',
  },
]

export default function Problem() {
  return (
    <section
      id="problem"
      style={{ borderTop: '1px solid var(--rule)', padding: 'var(--sec-y) var(--gutter)' }}
    >
      <div className="lp-wrap lp-two">
        {/* Three lines that step up in weight and size, so the last one
            lands as the claim the section is really making. */}
        <div className="lp-problem__lead">
          <h2>The threat evolves faster than we can field.</h2>
          <p>American industry can deliver what the warfighter needs.</p>
          <p className="lp-problem__turn">
            But the system for planning and executing programs was built in the
            20th century.
          </p>
        </div>

        <div className="lp-stack">
          {PROBLEMS.map((p) => (
            <div key={p.n} className="lp-stack__row">
              <div className="lp-stack__n">{p.n}</div>
              <div>
                <h3>{p.title}</h3>
                <p className="lp-p">{p.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
